export state = ->
	availableSites: null

export mutations =
	# Update list of available sites for a given route
	setAvailableSites: (state, availableSites) -> state.availableSites = availableSites
